// extracted by mini-css-extract-plugin
export default {"horizontalLine":"horizontal-line_horizontalLine__OOBkg"};